import React, { CSSProperties } from 'react';

interface CheckBadgeProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const CheckBadge: React.FC<CheckBadgeProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 1060 1060"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill={fill}>
        <defs/>
        <path d="M865.43 530c0-50.18-33.31-92.13-78.86-106.24 8.29-15.61 13.43-33.15 13.43-52.05 0-61.7-50.02-111.72-111.72-111.72-18.91 0-36.44 5.14-52.05 13.43-14.1-45.55-56.05-78.86-106.24-78.86s-92.13 33.31-106.24 78.86c-15.61-8.29-33.14-13.43-52.05-13.43-61.7 0-111.72 50.02-111.72 111.72 0 18.91 5.14 36.44 13.43 52.05-45.55 14.1-78.86 56.05-78.86 106.24s33.31 92.13 78.86 106.24c-8.29 15.61-13.43 33.14-13.43 52.05 0 61.7 50.02 111.72 111.72 111.72 18.91 0 36.44-5.14 52.05-13.43 14.1 45.55 56.05 78.86 106.24 78.86s92.13-33.31 106.24-78.86c15.61 8.29 33.15 13.43 52.05 13.43 61.7 0 111.72-50.02 111.72-111.72 0-18.91-5.14-36.44-13.43-52.05 45.55-14.1 78.86-56.05 78.86-106.24z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px"/>
        <path d="M665.89 438.66L483.21 621.34l-89.09-75.32" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px"/>
      </g>
    </svg>
  );
};

export default CheckBadge;
